import { Pipe, PipeTransform } from '@angular/core';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Pipe({name: 'cpdprice'})

export class CPDPrice implements PipeTransform {

  // TimeZone related configuration
  public DefaultTimeZone:boolean = true;
  public USATimeZone:boolean = false;
  public AustraliaTimeZone:boolean = false;
  public AucklandTimeZone:boolean = false;
  public HongKongTimeZone:boolean = false;
  public EUTimeZone:boolean = false;
  public CanadaTimeZone:boolean = false;
  public UAETimeZone:boolean = false;

  constructor(private timezoneService: TimeZoneService) {
    // console.log(this.getBasket());
    this.DefaultTimeZone = this.timezoneService.checkDefaultTimeZone();
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
    this.AustraliaTimeZone = this.timezoneService.checkAustraliaTimeZone();
    this.AucklandTimeZone = this.timezoneService.checkAucklandTimeZone();
    this.HongKongTimeZone = this.timezoneService.checkHongKongTimeZone();
    this.EUTimeZone = this.timezoneService.checkEUTimeZone();
    this.CanadaTimeZone = this.timezoneService.checkCanadaTimeZone();
    this.UAETimeZone = this.timezoneService.checkUAETimeZone();
  }

  transform(value: number): string {

    let price = (Number(value/100)||0).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    let currencySymbol = "£";

    if(this.AustraliaTimeZone){
      let rate = 2.01;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "AUD$";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    if(this.AucklandTimeZone){
      let rate = 2.32;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "NZ$";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    if(this.HongKongTimeZone){
      let rate = 10.23;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "HK$";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    if(this.USATimeZone){
      let rate = 1.31;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "$";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    if(this.EUTimeZone){
      let rate = 1.13;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "€";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    if(this.CanadaTimeZone){
      let rate = 1.84;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "C$";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    if(this.UAETimeZone){
      let rate = 4.83;
      price = (rate * parseInt(price)).toFixed(2);
      currencySymbol = "AED";
      let finalPrice = Math.round(Number(price));

      return currencySymbol+finalPrice;
    }

    return currencySymbol+price;
  }
}